module.exports = __webpack_public_path__ + "media/site/images/case_studies/eplanning/solution3_1@2x-817e7c4a08c430375b165883b9713559.png";